import parse from 'style-parser'
import { arrowCssProperty } from '../const/_sanitize'
import { isUrl, objectToGet } from '../functions/index'

/**
 * AttrsCheck // 属性値のCheck
 */

class AttrsCheck {
  constructor() {
    this.config = arrowCssProperty
  }

  /**
   * start // 属性値のCheckを行う
   *
   * @param {string} name // 属性名
   * @param {string} value // 属性の値
   *
   * @returns {object}
   */
  start(name, value) {
    const result = {
      name: name,
      value: value,
    }
    // defaultのコンフィグにマージ
    if (name === 'style') result.value = this.style(value)
    if (name === 'href') result.value = this.url(value)
    if (name === 'src') result.value = this.url(value)
    return result
  }

  /**
   * style // 許可されたプロパティーのみにする
   *
   * @param {string} value
   *
   * @returns {string}
   */
  style(value) {
    const result = []
    const style = parse(value)

    const arrowCssProperty = this.config
    arrowCssProperty.forEach(item => {
      const val = this.get(style, item)
      if (val) result.push({ name: item, value: val })
    })

    let resultStyle = ''
    result.forEach(item => {
      resultStyle += `${item.name}: ${item.value};`
    })
    return resultStyle
  }

  /**
   * url // urlか判定する
   *
   * @param {string} value
   * @return string
   */
  url(value) {
    const url = isUrl(value)
    if (url) return value
    return ''
  }

  /**
   * get.// データを取得する
   *
   * @param {object} object
   * @param {string} namespace
   * @param {any} defaultValue
   */
  get(object, namespace, defaultValue) {
    return objectToGet(object, namespace, defaultValue)
  }
}

export default new AttrsCheck()
